import { queryParams, type RouteQueryOptions, type RouteDefinition, applyUrlDefaults } from './../../../../../wayfinder'
/**
* @see \App\Http\Controllers\Supplier\GetSupplierActivitiesByIdController::__invoke
* @see app/Http/Controllers/Supplier/GetSupplierActivitiesByIdController.php
* @route '/api/supplier/{supplier}/activities'
*/
const GetSupplierActivitiesByIdController = (args: { supplier: string | number | { id: string | number } } | [supplier: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: GetSupplierActivitiesByIdController.url(args, options),
    method: 'get',
})

GetSupplierActivitiesByIdController.definition = {
    methods: ["get","head"],
    url: '/api/supplier/{supplier}/activities',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\Supplier\GetSupplierActivitiesByIdController::__invoke
* @see app/Http/Controllers/Supplier/GetSupplierActivitiesByIdController.php
* @route '/api/supplier/{supplier}/activities'
*/
GetSupplierActivitiesByIdController.url = (args: { supplier: string | number | { id: string | number } } | [supplier: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { supplier: args }
    }

    if (typeof args === 'object' && !Array.isArray(args) && 'id' in args) {
        args = { supplier: args.id }
    }

    if (Array.isArray(args)) {
        args = {
            supplier: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        supplier: typeof args.supplier === 'object'
        ? args.supplier.id
        : args.supplier,
    }

    return GetSupplierActivitiesByIdController.definition.url
            .replace('{supplier}', parsedArgs.supplier.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\Supplier\GetSupplierActivitiesByIdController::__invoke
* @see app/Http/Controllers/Supplier/GetSupplierActivitiesByIdController.php
* @route '/api/supplier/{supplier}/activities'
*/
GetSupplierActivitiesByIdController.get = (args: { supplier: string | number | { id: string | number } } | [supplier: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: GetSupplierActivitiesByIdController.url(args, options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Supplier\GetSupplierActivitiesByIdController::__invoke
* @see app/Http/Controllers/Supplier/GetSupplierActivitiesByIdController.php
* @route '/api/supplier/{supplier}/activities'
*/
GetSupplierActivitiesByIdController.head = (args: { supplier: string | number | { id: string | number } } | [supplier: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: GetSupplierActivitiesByIdController.url(args, options),
    method: 'head',
})

export default GetSupplierActivitiesByIdController